import { useEffect, useState } from 'react';
import './Home.css';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import  '../assets/css/dataTables.bootstrap4.min.css';
import backgroundImage from '../assets/img/fondo-diseno.jpg';


function Home() {
    const navigate = useNavigate();
    const [startTime, setStartTime] = useState("")
    const [dashboard, setDashboard] = useState(true)
    const [getcsv, setGetCsv] = useState(false)
    const [exceldata, setexceldata] = useState([])
    const [endTime, setEndTime] = useState("")
    const [humidityOptions, setHumidityOptions] = useState({
        title: {
            text: ''
        },
        xAxis: {
          data:['123'],
            title: { text: 'Time' },
            labels: {
                enabled:false,
            }
        },
        yAxis: {
            title: { text: 'Humidity (%)' }
        },
        credits: {
            enabled: false
          },
        series: [{
            color: '#007bff',
            data: [],
            line: {
                animation: false,
                dataLabels: { enabled: false }
            },
          
            name:"Humidity"
        }]
    });

    const [temperatureOptions, setTemperatureOptions] = useState({
        title: {
            text: ''
        },
       
        xAxis: {
    type: 'datetime',
    title: { text: 'Time' },
    labels: {
        enabled:false,
        formatter: function () {
            return Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', this.value);
        }
    }
},
        yAxis: {
            title: { text: 'Temperature (Celsius)' }
        },
        credits: {
            enabled: false
          },
        series: [{
            color: '#007bff',
            data: [],
            line: {
                animation: false,
                dataLabels: { enabled: false }
            },
            name:"Temperature"
        }]
    });
    const [totalUsers,setTotalUsers] = useState(0)
    const [data,setData] = useState([])
    const getmac = async() =>{
        const login = localStorage.getItem('cid');
        fetch('https://msensorapi.coolproyectdata.online/getmac.php',{
            method: "POST",
                   // crossorigin: true,    
                   // mode: 'no-cors', 
                    headers: {
                    Accept: "application/json",
                   "Content-Type": "application/json",

                    },
                    body:JSON.stringify({
                        "get_cid":login?.split("")[1]
                    })
                    })
      .then(response => response.json())
      .then(data => {
       // console.log(data)
        const select = document.getElementById('mac');
        // const uniqueMacAddresses = new Set();
        const option2 = document.createElement('option');
        option2.style.color="#000";
            option2.value = "Select Mac Address";
            option2.textContent = "Select Mac Address";
    select.innerHTML = '';
    select.appendChild(option2);
    if(data.status==="History Not Found"){

    }else{
    setTotalUsers(data?.length)
    setData(data)
    }
       for(var i=0;i<data.length;i++){
       
            const option = document.createElement('option');
            option.value = data[i].macAddress;
            option.textContent = data[i].macAddress;
            select.appendChild(option);
      
    }
    }).catch(error=>{
        console.log(error)
    })
    }
    const getmac2 = async() =>{
        const login = localStorage.getItem('cid');
        fetch('https://msensorapi.coolproyectdata.online/getmac.php',{
            method: "POST",
                   // crossorigin: true,    
                   // mode: 'no-cors', 
                    headers: {
                    Accept: "application/json",
                   "Content-Type": "application/json",

                    },
                    body:JSON.stringify({
                        "get_cid":login?.split("")[1]
                    })
                    })
      .then(response => response.json())
      .then(data => {
       console.log(data)
       if(data.status==="History Not Found"){

       }else{
        setTotalUsers(data?.length)
        setData(data)
       }
   
    }).catch(error=>{
        console.log(error)
    })
    }


    const getAllHistory = async () => {
        // Reset options
        const login = localStorage.getItem('cid');
        const macaddress = document.getElementById("mac").value
        if(macaddress === "Select Mac Address"){
            alert("Select Mac Address")
                    }else{
        console.log(login?.split(""),"cid",macaddress,"mac")
        setHumidityOptions(prevOptions => ({
            ...prevOptions,
            series: [{ ...prevOptions.series[0], data: [] }]
        }));
        setTemperatureOptions(prevOptions => ({
            ...prevOptions,
            series: [{ ...prevOptions.series[0], data: [] }]
        }));

        try {
            const response = await fetch(`https://msensorapi.coolproyectdata.online/getallhistory.php`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify({
                    "cid": login?.split("")[1],
                    "mac": macaddress
                })
            });

            const responseData = await response.json();
            console.log(responseData);

            const humidityData = responseData.map(item => [item.timestamp, parseFloat(item.humidity)]);
            const temperatureData = responseData.map(item => [item.timestamp, parseFloat(item.temperature)]);

            setHumidityOptions(prevOptions => ({
                ...prevOptions,
                series: [{ ...prevOptions.series[0], data: humidityData }]
            }));

            setTemperatureOptions(prevOptions => ({
                ...prevOptions,
                series: [{ ...prevOptions.series[0], data: temperatureData }]
            }));
            setexceldata(responseData)
            setGetCsv(true)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    };


    const getHistory = async () => {
        // Reset options 2024-08-28T10:31   26-8-2024 12:55  28-08-2024 10:34   
     
        const login = localStorage.getItem('cid');
        const macaddress = document.getElementById("mac").value
        if(macaddress === "Select Mac Address"){
alert("Select Mac Address")
        }else{
        var sttime = startTime?.split(/[T-]+/)
        const stmonth = sttime[1]?.slice(0,-1)===0 || sttime[1]?.slice(0,-1)==='0' ? sttime[1]?.slice(1) : sttime[1]
        var entime = endTime?.split(/[T-]+/)
        const enmonth = entime[1]?.slice(0,-1)===0 || entime[1]?.slice(0,-1)==='0' ? entime[1]?.slice(1) : entime[1]
        console.log(stmonth,"stmonth",enmonth,"enmonth")
        console.log(login?.split(""),"cid",macaddress,sttime[2]+"-"+stmonth+"-"+sttime[0]+" "+sttime[3],entime[2]+"-"+enmonth+"-"+entime[0]+" "+entime[3])

        setHumidityOptions(prevOptions => ({
            ...prevOptions,
            series: [{ ...prevOptions.series[0], data: [] }]
        }));
        setTemperatureOptions(prevOptions => ({
            ...prevOptions,
            series: [{ ...prevOptions.series[0], data: [] }]
        }));

        try {
            const response = await fetch(`https://msensorapi.coolproyectdata.online/gethistory.php`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify({
                    "get_cid":login?.split("")[1],
                    "get_mac":macaddress,
                    "get_starttime":sttime[2]+"-"+stmonth+"-"+sttime[0]+" "+sttime[3],
                    "get_endtime":entime[2]+"-"+enmonth+"-"+entime[0]+" "+entime[3]
                })
            });
      
            const responseData = await response.json();
            console.log(responseData);
            if(responseData.status === "History Not Found"){
alert("History Not Found")
            }else{

            const humidityData = responseData.map(item => [item.timestamp, parseFloat(item.humidity)]);
            const temperatureData = responseData.map(item => [item.timestamp, parseFloat(item.temperature)]);

            setHumidityOptions(prevOptions => ({
                ...prevOptions,
                series: [{ ...prevOptions.series[0], data: humidityData }]
            }));

            setTemperatureOptions(prevOptions => ({
                ...prevOptions,
                series: [{ ...prevOptions.series[0], data: temperatureData }]
            }));
            setexceldata(responseData)
            setGetCsv(true)

        }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    };


    const deletedevice = async(mac) =>{
        const login = localStorage.getItem('cid');
        try {
            const response = await fetch(`https://msensorapi.coolproyectdata.online/getmac.php`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify({
                    "delete_cid":login?.split("")[1],
                    "delete_mac":mac
                })
            });
      
            const responseData = await response.json();
            console.log(responseData);
            window.location.reload()
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(exceldata);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'history.xlsx');
      };
   
       useEffect(() => {
           const login = localStorage.getItem('cid');
       const parsedLogin = login?.slice(1, -1); // Remove quotes, if any
          
          console.log(parsedLogin, parseInt(parsedLogin), "cid");
    
          if (
            !login || // Handles null, undefined, or empty string
            parsedLogin === "null" || 
            parsedLogin === "undefined" || 
            parseInt(parsedLogin) === 6
          ) {
            localStorage.removeItem('cid');
            navigate('/');
          } else {
            getmac2();
        //     console.log(parsedLogin, "login already exists");
      }
      }, []);
return (
    <div className="u-body u-xl-mode"
    data-lang="en"  style={{ backgroundImage: `url(${backgroundImage})` }}>
        <header className="header">
       
              <div style={{width:"155px",backgroundColor:"#fff",display:"flex",padding:"5px",justifyContent:"center",
        alignItems:"center",boxShadow: '0 4px 2px rgba(0, 0, 60,0.2)',borderRadius:"5px",cursor:"pointer"}}
    onClick={()=>{setDashboard(!dashboard);dashboard === true?getmac():getmac2()}} >

      <span style={{ fontSize:'20px', color: '#007bff',alignSelf:"center",
      justifySelf:"center",fontWeight:"600px" }}>{dashboard === true?"View History":"Main Page"}</span>
      </div>
      <div className="header2">

            <img
                alt=""
                src={require('./images/right.png')}
                id="sg"
                onClick={() => {
                    localStorage.removeItem('cid');
                    navigate('/');
                }}
            />
            <span id="sp" style={{cursor:"pointer"}} onClick={() => {
                    localStorage.removeItem('cid');
                    navigate('/');
                }}>Sign Out</span>
                </div>
        </header>
{dashboard?
        <> <div style={{display:"flex",flexDirection:"row",width: '98%',fontSize:"20px"}}>
        <div style={{color:"#fff",textAlign:"left",alignSelf:"flex-start",marginLeft:"1%"}}>
        List of Existing Devices:</div>
          <div style={{color:"#fff",textAlign:"left",alignSelf:"flex-start",marginLeft:"1%",fontWeight:"600"}}>{totalUsers}</div>
        </div>
        
        <div style={{width: '100%', maxHeight: '560px',padding:"20px" }}>
        <div
        
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '20px',
          border: '0px solid #ddd',
          borderRadius: '8px',
          backgroundColor: '#007bff',
          boxShadow: '0 4px 2px rgba(0, 0, 60,0.2)',
         // transition: 'transform 0.3s ease',
          fontWeight:"600"
        }}
        // onMouseEnter={(e) => {e.currentTarget.style.transform = 'scale(1.05)';
        // e.currentTarget.style.backgroundColor = '#fdfdfd';}}
        // onMouseLeave={(e) => {e.currentTarget.style.transform = 'scale(1)';
        // e.currentTarget.style.backgroundColor = '#fff'}}
      >
        <div style={{ flex: '1', paddingRight: '20px' }}>
          <h3 style={{ margin: '0', fontSize: '18px', color: '#fff',fontWeight:"600" }}>Name</h3>
    
        </div>
        <div style={{ flex: '1', paddingRight: '20px' }}>
          <h3 style={{ margin: '0', fontSize: '18px', color: '#fff',fontWeight:"600" }}>MacAddress</h3>
        </div>
        <div  style={{ flex: '1',cursor:"pointer" }}>
          <h3 style={{ margin: '0', fontSize: '18px', color: '#fff',fontWeight:"600" }}>Delete</h3>
        </div>
      </div>
      <div   className="table-responsive"
    style={{ maxHeight: "560px", overflowY: "auto" }} >
      {data?.map((item, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '20px',
            margin: '10px 0',
            border: '0px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 2px rgba(0, 0, 60,0.2)',
            transition: 'transform 0.3s ease',
            fontWeight:"600"
          }}
          onMouseEnter={(e) => {e.currentTarget.style.transform = 'scale(1.05)';
          e.currentTarget.style.backgroundColor = '#fdfdfd';}}
          onMouseLeave={(e) => {e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.backgroundColor = '#fff'}}
        >

          <div style={{ flex: '1', paddingRight: '20px',width:"40px",overflow:"hidden"}}>
            <p style={{ margin: '5px 0', fontSize: '16px', color: '#007bff' }}>{item?.name}</p>
          </div>
          <div style={{ flex: '1' }}>
            <p style={{ margin: '5px 0', fontSize: '16px', color: '#555' }}>{item?.macAddress}</p>
          </div>
          <div onClick={()=>deletedevice(item?.macAddress)} style={{ flex: '1',cursor:"pointer" }}>
            <i style={{ margin: '5px 0', fontSize: '20px', color: '#555' }} className="fa fa-trash"></i>
          </div>
        </div>
      ))}
      </div>
    </div></> :
                 <>
                    <div style={{width:"100%",alignItems:"center",display:"flex",flexDirection:"column"}}>
                 <div className="form-container" style={{alignSelf:"center",}}>
                    
                 <div className="form-group">
                     <label style={{ color: "#fff" }}>Select Mac</label>
                     <select style={{ color: "#000" }} id="mac"></select>
                 </div>
                 <div className="form-group">
                     <label style={{ color: "#fff" }}>Start Time</label>
                     <input
                         style={{ color: "#000" }}
                         type="datetime-local"
                         onChange={(e) => setStartTime(e.target.value)} />
                 </div>
                 <div className="form-group">
                     <label style={{ color: "#fff" }}>End Time</label>
                     <input
                         style={{ color: "#000" }}
                         type="datetime-local"
                         onChange={(e) => setEndTime(e.target.value)} />
                 </div>
                 <div className="button-container">
                     <button style={{ fontWeight: "600" }} onClick={()=>getHistory()}>GET HISTORY</button>
                     <button style={{ fontWeight: "600" }} onClick={()=>getAllHistory()}>GET ALL HISTORY</button>
                     {getcsv?
                     <button onClick={exportToExcel} style={{ fontWeight: "600",alignItems:"center",justifyContent:"center",display:"flex" }} >
                     <img alt="" src={require("./images/logo.png")} style={{width:"30px",height:"auto",}} />
                   </button>:null}
                 </div>
             </div>
             <div className="charts-container">
                     <div className="chart-card">
                         <HighchartsReact
                             highcharts={Highcharts}
                             options={temperatureOptions} />
                     </div>
                     <div className="chart-card">
                         <HighchartsReact
                             highcharts={Highcharts}
                             options={humidityOptions} />
                     </div>
                     <div>
                     
                     </div>
                   
                 </div>
                 </div>
                 </>
                
}
    </div>
);
}

export default Home;

